import { createContext, useContext } from 'react';

export type Release = {
  id?: string;
  releaseDate?: string;
  year: number;
  resource?: string;
};

type YearsType = {
  availableYears: {
    [key: string]: Release[];
  };
};

export const defaultYearsContext = {
  availableYears: {
    wur: [],
    sed: [],
    sdg: [],
    reputation: [],
    japanrankingdashboard: [],
    'new-data': [],
    cid: [],
    latam: [],
    crd: [],
    'wur-reporter': [],
    explore: [],
    resources: [],
  },
};

const YearsContext = createContext<YearsType>({
  ...defaultYearsContext,
});

export const useYears = () => useContext(YearsContext);

export default YearsContext;
